<!--
 * @FilePath: Home.vue
 * @Author: 孙新宇
 * @Date: 2022-12-27 09:15:51
 * @LastEditTime: 2022-12-31 10:45:56
 * @Descripttion: 
-->
<template>
  <div class="home">
    <h1>舜泰知识库</h1>
    <div class="btn" style="padding: 0 15px">
      <van-button
        class="btn-1"
        round
        type="default"
        size="large"
        @click="toList(1)"
      >
        使用手册
      </van-button>
      <van-button
        class="btn-1"
        round
        type="default"
        size="large"
        @click="toList(2)"
      >
        常见问题
      </van-button>
      <van-button
        type="default"
        round
        size="large"
        class="btn-1"
        @click="toList(3)"
      >
        车辆排障
      </van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Button, Toast } from "vant";
// import { useUserStore } from "../store";
// import * as dd from "dingtalk-jsapi";
// import { queryUserInfo } from "../http";

Vue.use(Button);
Vue.use(Toast);

export default {
  methods: {
    toList(flag) {
      // const user = useUserStore();

      if (flag === 1) {
        // user.userLogin();
        // Toast(user.userStatus);
        this.$router.push({ name: "article", params: { category: 1 } });
      } else if (flag === 2) {
        // user.userExpire();
        // Toast(user.userStatus);
        this.$router.push({ name: "article", params: { category: 2 } });
      } else {
        this.$router.push({ name: "article", params: { category: 3 } });
      }
    },
  },
  mounted() {
    // const user = useUserStore();
    // user.userLogin();
    // Toast(user.userStatus);
    // 获取code 然后获取 dd_user_id
    // localStorage.clear();
    // console.log(localStorage.getItem("userStatus"));
    // let userStatus = localStorage.getItem("userStatus");
    // Toast(userStatus);
    // if (userStatus != 1) {
    // }
  },
};
</script>

<style>
.home {
  height: 100vh;
  background-image: url("../assets/images/bg_9.png");
  background-size: auto;
  background-repeat: no-repeat;
  background-position: center top;
}
h1 {
  text-align: center;
  transform: translateY(200px);
}
.btn {
  margin-top: 300px;
}
.btn-1 {
  margin-bottom: 12px;
}
</style>